import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { CheckoutPage, type OrderDetails } from "../checkout-page";

export const CheckoutContainer = memo(function CheckoutContainer() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/");
  };

  const handleOrderComplete = (orderDetails: OrderDetails) => {
    navigate("/checkout/success");
  };

  return (
    <CheckoutPage onBack={handleBack} onOrderComplete={handleOrderComplete} />
  );
});
